import React, { useCallback } from 'react';
import Title from 'components/UI/Title';
import Hint from 'components/UI/Hint';
import Checkbox from 'components/UI/Checkbox';
import * as styles from './Desktop.module.scss';

function CheckboxDesktop({ name, hint, value, onChange }) {
  const handleClick = useCallback(
    (label, checked) => {
      onChange(label, checked);
    },
    [name, value],
  );

  return (
    <Checkbox className={styles.label} onChange={() => handleClick(name, !value)} checked={value}>
      <Title tag="h4" size={false} className={styles.title}>
        <span>{name}</span>
        {hint && (
          <span className={styles.hint}>
            <Hint withIcon showOnlyOne content={hint} zIndex={100} />
          </span>
        )}
      </Title>
    </Checkbox>
  );
}

export default React.memo(CheckboxDesktop);
